import vue from "../main";

export default function() {
  return [
    { id: 1, name: vue.$t("$staticData.vehicleTypes.car") },
    { id: 2, name: vue.$t("$staticData.vehicleTypes.truck") },
    { id: 3, name: vue.$t("$staticData.vehicleTypes.motorcycle") },
    { id: 4, name: vue.$t("$staticData.vehicleTypes.moped") }
  ];
}
